import React, { Component } from 'react'
import i18next from 'i18next'
import { Link } from 'react-router'

import buttonStyles from './styles/button.scss'
import resultsStyle from './styles/no-results.scss'

import illustration from '../assets/images/wopi-clipped-snap.png'

export default class NoWopi360Results extends Component {
  render() {
    return (
      <div className={resultsStyle.container}>
        <div>
          <img src={illustration} style={{ width: '100px' }} />

          <h2>{i18next.t('no_results')}</h2>

          <p>{i18next.t(this.props.translationKey)}</p>
        </div>

        <div style={{ marginTop: 40 }}>
          <Link to="/new-target" className={buttonStyles.button}>
            {i18next.t('new_wopi360_target')}
          </Link>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/NoWopi360Results.js